import React, { Component } from 'react';
import {inject,observer} from 'mobx-react';
import './index.less';
const {dialog} = window.DN.Modal;


@inject('dashboardStore')
@observer
class Banner extends Component {
  constructor(props){
    super(props);
    this.state={
    };
  }
  componentDidMount() {
    this.props.dashboardStore.fetchDialogData();
  }
  showDialog = () =>{
    dialog({
      title: '活动规则',
      content: this.props.dashboardStore.dialogContent,
      size: 'middle',
      button: [
        {
          text: '好的',
        }
      ]
    });
  }
  //banner图和活动规则的展示
  render() {
    return (
      <div className="banner-wrap">
        {/* <div className="just-block">12</div> */}
        <div className="banner">
          <div className="small-title">
            {window.tms.moduleinfo.mainTitle}
          </div>
          <div className="rule-btn" onClick={this.showDialog} data-spm-click="gostr=/aliyun;locaid=showDialog">
            活动规则
          </div>
        </div>
      </div>
    );
  }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/scripts/components/Banner/index.js